import { Button, Spinner } from "react-bootstrap";

export const iDocumentStages = {
  NOT_PICKED: "NOT_PICKED",
  PICKED: "PICKED",
  UPLOADED: "UPLOADED",
  UPLOAD_FAILED: "UPLOAD_FAILED",
};
export function removeNullKeys(payload) {
  for (const key in payload) {
    if (payload[key] === null) {
      delete payload[key];
    }
  }
}

export function documentWidget(document, retryFunction) {
  switch (document.status) {
    case iDocumentStages.NOT_PICKED:
      return <></>;

    case iDocumentStages.PICKED:
      return <Spinner size="sm"></Spinner>;
    case iDocumentStages.UPLOADED:
      return <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>;
    case iDocumentStages.UPLOAD_FAILED:
      return (
        <Button
          className="p-2 py-0 mx-1"
          onClick={() => {
            retryFunction(document);
          }}
        >
          {" "}
          Retry
        </Button>
      );

    default:
      return <></>;
  }
}
export const documentAccpetedTypes =
  "image/gif, image/jpeg, image/png, image/jpg, application/pdf";
